import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { SetUserContext } from "..";

const Logout = () => {
  const setUser = useContext(SetUserContext);
  const navigate = useNavigate();

  useEffect(() => {
    window.sessionStorage.removeItem('jwtToken');
    axios.defaults.headers.common['Authorization'] = null;
    setUser(null);
    navigate("/");
  });

};

export default Logout;